<template>
  <Select v-model="state" :placeholder="placeholder" @on-change="change_value">
    <Option
      v-for="(item, index) in options"
      :value="item.value"
      :key="`${index}-${item.value}`"
    >
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    val: {
      type: Number
    },
    placeholder: {
      type: String,
      default: "请选择状态"
    }
  },
  data() {
    return {
      state: "",
      options: [
        { value: 0, label: "全部状态" },
        { value: 1, label: "自发货在售" },
        { value: 2, label: "fba在售" },
        { value: 3, label: "转移已停售" },
        { value: 4, label: "淘汰" },
        { value: 5, label: "未上架" },
        { value: 8, label: "无授权新图FBA" },
        { value: 9, label: "转移中" },
        { value: 10, label: "抛货" },
        { value: "10,2", label: "fba在售/抛货" }
      ]
    };
  },
  watch: {
    val: {
      handler(val) {
        console.log(val);
        this.state = val;
      }
    }
  },
  methods: {
    change_value(val) {
      let params;
      if (val === "10,2") {
        params = getParams("ispass", val, "IN");
      } else {
        params = getParams("ispass", val, "=");
      }
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseState.vue